import React, { useCallback, useState, ReactElement } from 'react';
import Card from '../card/card.component';
import Button from '../button/button.component';
import ModalButtonBlock from '../modal-button-block/modal-button-block.component';
import ModalLayout from '../modal-layout/modal-layout.component';
import ModalLabel from '../modal-label/modal-label.component';
import ModalFieldBlock from '../modal-field-block/modal-field-block.component';
import FieldNumber from '../field-number/field-number.component';
import ErrorBlock from '../error-block/error-block.component';
import LineBreak from '../line-break/line-break.component';

const VerifyPhoneModal: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isOpen,
    phone,
    errorMessage,
    onCloseModal,
    onVerifyPhoneConfirm,
  } = props;

  const [verificationCode, setVerificationCode]: [string | null, Function] = useState(null);

  const verifyPhoneConfirm: MouseEventHandlerFunction = useCallback((): void => {
    if (onVerifyPhoneConfirm && phone) {
      onVerifyPhoneConfirm(verificationCode, phone, (): void => {
        setVerificationCode(null);
      });
    }
  }, [verificationCode, phone]);

  const onCodeFieldChange: Function = useCallback((value: string): void => {
    setVerificationCode(value);
  }, []);

  return (
    <ModalLayout isOpen={isOpen} title="Phone Verification" onCloseModal={onCloseModal}>
      <Card isContainer>
        <ModalLabel>
          We&apos;ve just texted phone with a number
          {' '}
          {phone}
          .
          <LineBreak />
          Please enter the code and confirm.
        </ModalLabel>
        <ModalFieldBlock isDefault>
          <FieldNumber
            isPlain
            isShort
            isBordered
            withNoCommas
            withNoAutocomplete
            value={verificationCode}
            onChange={onCodeFieldChange}
          />
        </ModalFieldBlock>
      </Card>
      <ModalButtonBlock>
        <Button onClick={onCloseModal}>
          Cancel
        </Button>
        <Button isActive onClick={verifyPhoneConfirm}>
          Confirm
        </Button>
      </ModalButtonBlock>
      {
        !!errorMessage && (
          <ErrorBlock errorMessage={errorMessage} />
        )
      }
    </ModalLayout>
  );
});

export default VerifyPhoneModal;
